import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { getLocationById } from '../data/locations';
import ContactForm from '../components/ContactForm';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaArrowLeft } from 'react-icons/fa';

const SanFranciscoPage: React.FC = () => {
  const location = getLocationById('san-francisco');

  if (!location) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="san-francisco-page">
      <Header>
        <Link to="/" className="nav-back">
          {React.createElement(FaArrowLeft as React.ComponentType)} Back to Main
        </Link>
        <a href="#barbers">Barbers</a>
        <a href="#booking">Booking</a>
        <a href="#contact">Contact</a>
      </Header>

      {/* Page Header */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="breadcrumb">
            <Link to="/">Home</Link> / <span>San Francisco</span>
          </div>
          <h1>Metropolitan Barbershop</h1>
          <h2>San Francisco Location</h2>
          <p>Experience the finest in classic barbering in San Francisco</p>
        </div>
      </section>

      {/* Barbers Section */}
      <section id="barbers" className="barbers">
        <div className="container">
          <h2>Meet Our San Francisco Barbers</h2>
          {location.barbers.length > 0 ? (
            <div className="barbers-grid">
              {location.barbers.map((barber, index) => (
                <div key={index} className="barber-card">
                  <div className="barber-image">
                    <img src={barber.image} alt={barber.name} />
                  </div>
                  <div className="barber-content">
                    <h3>{barber.name}</h3>
                    <p>{barber.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="coming-soon-barbers">
              <p>Our talented barber team will be announced soon!</p>
            </div>
          )}
        </div>
      </section>

      {/* Booking Section */}
      <section id="booking" className="booking">
        <div className="container">
          <div className="booking-content">
            <h2>Book Your Appointment</h2>
            {location.bookingStatus === 'active' && location.bookingUrl ? (
              <>
                <p>Book your appointment at our {location.name} location</p>
                <div className="booking-info">
                  <a href={location.bookingUrl} className="btn btn-primary btn-large">
                    BOOK ONLINE - {location.name}
                  </a>
                  <div className="booking-details">
                    <div className="cash-only">
                      <strong>$CASH ONLY$</strong>
                      <p>An ATM is available in the barbershop and there are multiple others in the surrounding area.</p>
                    </div>
                    <div className="phone-booking">
                      <p>Also phone in for appointments:</p>
                      <p><strong>{location.city} {location.phone}</strong></p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="booking-coming-soon">
                <h3>Booking Coming Soon!</h3>
                <p>Our {location.name} location will be opening soon. Stay tuned for booking availability!</p>
                <p>In the meantime, check out our <Link to="/san-jose">San Jose location</Link></p>
              </div>
            )}

            <div className="booking-policies">
              <div className="policy">
                <h4>CONFIRMATION REQUIRED</h4>
                <p>In unfortunate circumstances, online appointments may not go through. Make sure to check email for confirmation of appointment. If reschedule or cancellation is needed, a link is provided in the confirmation email. You can also call the shop to cancel or notify us if you'll be late.</p>
              </div>
              <div className="policy">
                <h4>10 MINUTE POLICY</h4>
                <p>Customers later than 10 minutes of appointment will not be able to be accommodated and can reschedule.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactForm
        location={location}
        formsparkId="aA2Y8Dl9d"
        botpoisonKey="pk_3c7a6b2a-df50-43b9-91d6-9e518c58c7f4"
      />

      <Footer />
    </div>
  );
};

export default SanFranciscoPage; 